import styled from 'styled-components';

export const StepperWrapper = styled('div')`
  display: flex;
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 16px;
`;

export const StepperItemFirst = styled.div`
  background-color: ${(props) => props.color};
  opacity: ${(props) => props.opacity};
  width: 25%;
  height: 4px;
  border-radius: 10px;
  border: 1px solid #c3cfd6;
  @media screen and (max-width: 576px) {
    width: 27%;
  }
`;

export const StepperItem = styled.div`
  background-color: ${(props) => props.color};
  opacity: ${(props) => props.opacity};
  width: 25%;
  height: 4px;
  border-radius: 10px;
  border: 1px solid #c3cfd6;
  margin-left: auto;
  margin-right: auto;
  @media screen and (max-width: 576px) {
    width: 27%;
  }
`;

export const StepperItemLast = styled.div`
  background-color: ${(props) => props.color};
  opacity: ${(props) => props.opacity};
  width: 25%;
  height: 4px;
  border-radius: 10px;
  border: 1px solid #c3cfd6;
  @media screen and (max-width: 576px) {
    width: 27%;
  }
`;
